import { useEffect, useRef, useState } from "react";

/**
 * Smoothly animates from previous value to a new target using easing.
 * Ideal for stat counters that update every few seconds via polling.
 */
export function useCountUp(target, duration = 900) {
  const [value, setValue] = useState(target ?? 0);
  const rafRef = useRef(null);
  const startRef = useRef({ from: value, to: target ?? 0, t0: performance.now() });

  useEffect(() => {
    if (target === null || target === undefined) return;
    startRef.current = { from: value, to: target, t0: performance.now() };

    const tick = (now) => {
      const { from, to, t0 } = startRef.current;
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const next = from + (to - from) * eased;
      setValue(next);
      if (p < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, duration]);

  return value;
}
